var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisinfect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_6);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_6",
    x1: 32.01,
    y1: 62.59,
    x2: 31.99,
    y2: -1.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3380fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2bb7ff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "z2_\u6D88\u6BD2\u767B\u8BB0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.73,23.34V20.63a2.41,2.41,0,0,0-2.41-2.41H34V15.27h8.7V12.19H22.89a8.56,8.56,0,0,0-7.16,4.53l2.64,1.58a5.56,5.56,0,0,1,4.44-3h8.13v2.95H26.6a2.43,2.43,0,0,0-2.42,2.41v2.71a8.55,8.55,0,0,0-7.5,8.46V48.53A3.3,3.3,0,0,0,20,51.81H45a3.28,3.28,0,0,0,3.29-3.28V31.8a8.54,8.54,0,0,0-7.54-8.46ZM37.47,39.92H34.15v3.32a1.67,1.67,0,0,1-3.34,0V39.92H27.49a1.67,1.67,0,1,1,0-3.33h3.32V33.27a1.67,1.67,0,0,1,3.34,0v3.32h3.32a1.67,1.67,0,1,1,0,3.33Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisinfect);
export default __webpack_public_path__ + "static/media/Disinfect.748e9a8f.svg";
export { ForwardRef as ReactComponent };